<template>
  <div class="container-header" :style="{ 'background-image': `url(${ currentPartner.banner })` }">
    <div class="container-header-inner">

      <!-- Product catalog button -->
      <button class="container-header-btn catalog"
              :class="{ 'icon-close': isCloseIconActive }"
              @click="toggleCategoryPanel"
      > {{ $t('Product catalog') }} </button>
      <!-- -->

      <!-- Search field block -->
      <div class="_wrapper-search">
        <input type="search"
               id="search"
               class="container-header-search"
               :class="{ 'is-focus': searchValue.length }"
               :placeholder="`${ $t('Search in') } ${ currentPartner.title }`"
               :value="searchValue"
               ref="search"
               autocomplete="off"
               data-hj-whitelist
               @input="searchValue = $event.target.value"
               @focus="closeBurgerMenu"
               @keyup.enter="showSearchPage($event.target.value)"
        >
        <button class="container-header-close"
                v-if="searchValue.length"
                @click.self="clearSearchInput"
        ></button>
      </div>
      <!-- -->

      <!-- Discounts page button -->
      <button @click="processPartnerLink('/discounts')" class="container-header-btn action">{{ $t('Discounts') }}</button>
      <!-- -->

      <!-- Categories multiple menu -->
      <category-nav-panel :is-categories-loaded="isCategoriesLoaded" :categories="tree" @changesIcon="changesIcon" />
      <!-- -->

      <!-- Search panel -->
      <search-panel v-if="searchValue.length" :search-value="searchValue" :is-search-page-active="isSearchPage" />
      <!-- -->

    </div>
  </div>
</template>

<script>
import CategoryNavPanel from 'theme/components/core/blocks/Shop/Navigation/CategoryNavPanel'
import SearchPanel from 'theme/components/core/blocks/Shop/Navigation/Search/SearchPanel'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CategoryNavPanel,
    SearchPanel
  },
  data () {
    return {
      isCloseIconActive: false,
      searchValue: '',
      isCategoriesLoaded: false
    }
  },
  created () {
    this.$bus.$on('clear-search-value', () => { this.searchValue = '' })
    this.$bus.$on('change-close-btn', () => { this.isCloseIconActive = false })
    this.$bus.$on('change-search-text', text => { this.searchValue = text })
    this.$bus.$on('changes-burger-icon', status => {
      if (window.innerWidth < 991) {
        this.isCloseIconActive = status
      }
    })
  },
  mounted () {
    this.getTree({ partner_code: this.currentPartner.code, location_code: this.currentPartner.location_code })
      .finally(() => this.isCategoriesLoaded = true)
  },
  watch: {
    searchValue () {
      if (this.$route.name !== 'search') {
        if (this.searchValue.length) {
          this.$bus.$emit('show-overlay-in-shop')
        } else {
          this.$bus.$emit('hide-search-panel')
          this.$bus.$emit('hide-overlay-in-shop')
        }
      } else {
        this.$bus.$emit('send-search-text-to-search-page', this.searchValue)
      }
    },
    '$route.params.store': {
      handler: function () {
        this.isCategoriesLoaded = false
        this.getTree({ partner_code: this.currentPartner.code, location_code: this.currentPartner.location_code })
          .finally(() => this.isCategoriesLoaded = true)
      }
    },
    '$route.query': {
      handler: function () {
        if (this.isSearchPage && this.searchValue !== this.$route.query.search && this.$route.query.search.length > 1) {
          this.searchValue = this.$route.query.search
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      getPartnerCategoryTree: 'category/getPartnerCategoryTree'
    }),
    getCurrentSlug () {
      return this.$route.params.slug
    },
    isSearchPage () {
      return this.$route.name === 'search'
    },
    tree () {
      return this.getPartnerCategoryTree(`${this.currentPartner.location_code}_${this.currentPartner.code}`)
    }
  },
  methods: {
    ...mapActions({
      getTree: 'category/getPartnerCategoryTree'
    }),
    // Toggle categories multiple menu
    toggleCategoryPanel () {
      if (window.innerWidth > 991) {
        this.$bus.$emit('toggle-category-panel')
      } else if ((this.getCurrentSlug && window.innerWidth < 991) || (!this.getCurrentSlug && window.innerWidth < 991)) {
        if (!this.isCloseIconActive) {
          this.$bus.$emit('show-burger-menu')
          this.$bus.$emit('show-overlay-in-shop')
          this.$bus.$emit('hide-search-panel')
        } else {
          this.$bus.$emit('hide-burger-menu')
          this.$bus.$emit('close-burger')
          this.$bus.$emit('hide-overlay-in-shop')
        }
        this.isCloseIconActive = !this.isCloseIconActive
      }
    },
    changesIcon (statusPanel) {
      if (window.innerWidth > 991) {
        this.isCloseIconActive = statusPanel;
      }
    },
    closeBurgerMenu () {
      if (!this.searchValue.length && window.innerWidth < 991) {
        this.$bus.$emit('hide-burger-menu')
        this.$bus.$emit('change-close-btn')
        this.$bus.$emit('hide-overlay-in-shop')
        this.$bus.$emit('close-burger')
      }
    },
    clearSearchInput () {
      this.searchValue = ''
    },
    processPartnerLink (page) {
      this.$router.push({ path: `${this.currentPartner.route}${page}` })
    },
    processPartnerSearch (query) {
      this.$router.push({ path: `${this.currentPartner.route}/search`, query: { search: query } })
    },
    showSearchPage (search) {
      if (search.length > 2) {
        this.$refs.search.blur();
      }
      if (!this.isSearchPage && search.length > 2) {
        this.$bus.$emit('hide-search-panel')
        this.$bus.$emit('hide-overlay-in-shop')
        this.processPartnerSearch(search)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper-search {
  position: relative;

  @media only screen and (max-width: 576px) {
    width: 100%;
  }
}

.container-header {
  width: 100%;
  margin-top: 55px;

  position: fixed;
  display: flex;
  justify-content: center;

  background-color: #fff;
  background-size: cover;
  background-repeat: no-repeat;
  z-index: 6;

  &-inner {
    width: 1140px;
    padding: 8px 0;

    position: relative;

    display: flex;
    align-items: center;

    @media only screen and (max-width: 1200px) {
      width: 946px;
      justify-content: space-between;
      padding: 8px 15px;
    }

    @media only screen and (max-width: 991px) {
      width: 722px;
    }

    @media only screen and (max-width: 768px) {
      width: 530px;
    }

    @media only screen and (max-width: 576px) {
      width: 100%;
    }
  }

  &-btn {
    padding: 10px 0;

    color: #fff;
    font-size: 12px;
    font-weight: 600;

    border: none;
    border-radius: 5px;

    background-size: 15px;
    background-repeat: no-repeat;

    outline: none;
    transition: .2s;

    &:hover {
      cursor: pointer;
    }

    &.catalog {
      padding-right: 73px;
      padding-left: 100px;

      background-image: url('../../../../assets/shop/catalog.png');
      background-position: 74px center;
      background-color: #f5a623;

      transition: .2s;

      &.icon-close {
        background-image: url('../../../../assets/shop/close-white.png');
      }

      &:hover {
        background-color: #f7b955;
      }

      @media only screen and (max-width: 1200px) {
        width: 263px;
        padding-left: 40px;
        padding-right: 0;
      }

      @media only screen and (max-width: 991px) {
        width: 150px;
        padding-left: 30px;
        background-position: 20px center;
      }

      @media only screen and (max-width: 768px) {
        width: 62px;
        height: 34px;
        font-size: 0;
        background-position: center;
        padding-left: 0;
      }
    }

    &.action {
      padding-right: 37px;
      padding-left: 64px;

      background-image: url('../../../../assets/shop/action.png');
      background-position: 38px center;
      background-color: rgba(#fff, .5);

      transition: .2s;

      @media only screen and (max-width: 1200px) {
        width: 132px;
      }

      @media only screen and (max-width: 768px) {
        width: 62px;
        height: 34px;
        font-size: 0;
        background-position: center;
        padding-right: 0;
        padding-left: 0;
      }

      &:hover {
        background-color: rgba(#f2f2f2, .3);
      }
    }
  }

  &-search {
    width: 530px;
    height: 13px;

    padding: 10px 15px;
    margin: 0 30px;

    border: none;
    border-radius: 5px;

    background-image: url('../../../../assets/shop/search.png');
    background-position: 530px center;
    background-size: 18px;
    background-repeat: no-repeat;

    color: #000;
    font-size: 14px;
    font-weight: 400;
    line-height: 0 !important;

    outline: none;
    box-sizing: content-box;
    transition: .2s;

    &::-webkit-search-cancel-button {
      display: none;
    }

    @media only screen and (min-width: 1200px) {
      &.is-focus {
        width: 520px;
        background-position: 10px center;
        padding: 10px 0 10px 40px;
      }
    }

    @media only screen and (max-width: 1200px) {
      width: 461px;
      background-size: 0;
    }

    @media only screen and (max-width: 991px) {
      width: 350px;
    }

    @media only screen and (max-width: 768px) {
      width: 380px;
      margin: 0 15px;
    }

    @media only screen and (max-width: 576px) {
      width: calc(100% - 60px);
    }
  }

  &-close {
    width: 30px;
    height: 30px;
    margin: auto;

    position: absolute;
    top: 0;
    right: 35px;
    bottom: 0;

    background-color: transparent;
    border: none;
    outline: none;

    background-image: url('../../../../assets/shop/close.svg');
    background-position: center;
    background-size: 15px;
    background-repeat: no-repeat;

    @media only screen and (max-width: 768px) {
      right: 20px;
    }
  }
}
</style>
